import React, { useState } from 'react';
import OpenSourceBox from './OpenSourceBox.jsx';
import DepartmentsMobileDropdown from './DepartmentMobileDropdown.jsx';


function Prototype({ prototype }) {
  const departments = [
    { id: 'ms', title: 'Mechanical Systems', data: prototype.ms },
    { id: 'hb', title: 'Hull & Body', data: prototype.hb },
    { id: 'es', title: 'Electrical Systems', data: prototype.es },
  ].filter(dept => dept.data);

  const [activeDepartmentId, setActiveDepartmentId] = useState(departments.length > 0 ? departments[0].id : null);
  
  const activeDepartment = departments.find(dept => dept.id === activeDepartmentId);
  
  const departmentBackground = activeDepartment?.data?.image || null;

  return (
    <div className="w-full">
      <div
        className="relative flex flex-col justify-center items-center w-full min-h-screen pt-10 pb-20 text-white font-custom"
        style={{
          backgroundImage: `url(${departmentBackground})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="hidden sm:flex flex-wrap justify-center items-center space-x-2 md:space-x-8 px-4 w-full max-w-screen-lg">
          {departments.map((department) => (
            <button
              key={department.id}
              onClick={() => setActiveDepartmentId(department.id)}
              className={`
                transition-all duration-300 ease-in-out cursor-pointer
                py-2 px-4 rounded-lg font-custom capitalize
                ${
                  activeDepartmentId === department.id
                    ? 'text-MainYellow text-3xl sm:text-6xl font-bold opacity-100'
                    : "text-gray-100 text-lg sm:text-xl opacity-60 hover:opacity-100 font-light"
                }
              `}
            >
              {department.title}
            </button>
          ))}
        </div>
   
        <div className="sm:hidden w-full flex justify-center">
          <DepartmentsMobileDropdown
            departments={departments}
            activeDepartmentId={activeDepartmentId}
            setActiveDepartmentId={setActiveDepartmentId}
          />
        </div>
        
        {departments.map((department) => (
          activeDepartmentId === department.id && (
            <div key={department.id} className="w-full flex justify-center my-8">
              <OpenSourceBox topics={department.data.topics} />
            </div>
          )
        ))}
      </div>
    </div>
  );
}

export default Prototype;